/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response schema for user profile age verification status GET endpoint.
 */
export interface AgeVerificationStatusResponse {
  /** True if user has a profile with age < 18, False otherwise. */
  is_user_age_prohibited: boolean;
}
